import axios from 'axios';
import configs from 'configs';
import { toast } from 'react-toastify';
import mockAdapter from './mock-adapter';

export const instance = axios.create({
  baseURL: configs.API_URL,
});
export const instanceApi = axios.create({
  baseURL: configs.API_URL,
});
mockAdapter(instance);
instanceApi.defaults.timeout = 300000;
instance.defaults.timeout = 300000;
instance.interceptors.request.use(
  async (config) => {
    if (localStorage.getItem('access_token')) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      };
    } else {
      delete axios.defaults.headers.common['Authorization'];
    }

    return config;
  },
  (error) => {
    delete axios.defaults.headers.common['Authorization'];
    Promise.reject(error);
  }
);

instanceApi.interceptors.request.use(
  (config) => {
    if (localStorage.getItem('access_token')) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      };
    } else {
      delete axios.defaults.headers.common['Authorization'];
    }
    return config;
  },
  (error) => {
    delete axios.defaults.headers.common['Authorization'];
    Promise.reject(error);
  }
);
// instance mock api
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalConfig = error.config;
    if (originalConfig.url !== '/login' && error.response) {
      if (error.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        if (error.response.data.message === 'jwt expired') {
          await instance
            .post('/refresh_token', {
              refresh_token: localStorage.getItem('refresh_token'),
            })
            .then((rs) => {
              const { access_token, refresh_token } = rs.data;
              localStorage.setItem('access_token', access_token);
              localStorage.setItem('refresh_token', refresh_token);
              return instance(originalConfig);
            })
            .catch(async (_error) => {
              localStorage.removeItem('access_token');
              localStorage.removeItem('refresh_token');
              localStorage.removeItem('role');
              localStorage.removeItem('user_name');
              localStorage.removeItem('cooperator_id');
              localStorage.setItem(
                'login_error_message',
                'トークンの有効期限が切れました。再度ログインしてください。'
              );
              await delete axios.defaults.headers.common['Authorization'];
              // @ts-ignore
              Promise.reject(_error);
              window.location.href = '/';
            });
        }
        if (error.response.data.message === 'meikantoku jwt expired') {
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('role');
          localStorage.removeItem('user_name');
          localStorage.removeItem('cooperator_id');
          localStorage.setItem(
            'login_error_message',
            'トークンの有効期限が切れました。再度ログインしてください。'
          );
          await delete axios.defaults.headers.common['Authorization'];
          // @ts-ignore
          window.location = '/';
        }
        if (error.response.data.message === 'No auth token') {
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('role');
          localStorage.removeItem('user_name');
          localStorage.removeItem('cooperator_id');
          localStorage.setItem(
            'login_error_message',
            'トークンの有効期限が切れました。再度ログインしてください。'
          );
          await delete axios.defaults.headers.common['Authorization'];
          // @ts-ignore
          window.location = '/';
        }
      }
    }

    return Promise.reject(error);
  }
);
// instance api
let tokenExpiredRetry = false;
instanceApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    let originalConfig = error.config;
    if (originalConfig?.url !== '/login' && error.response) {
      if (error.response.status === 401 && !tokenExpiredRetry) {
        tokenExpiredRetry = true;
        if (error.response.data.message === 'jwt expired') {
          const refreshTokenCurrent = await localStorage.getItem('refresh_token');
          await instanceApi
            .post('/refresh_token', {
              refresh_token: refreshTokenCurrent,
            })
            .then(async (rs) => {
              tokenExpiredRetry = false;
              const { access_token, refresh_token } = rs.data;
              await localStorage.setItem('access_token', access_token);
              await localStorage.setItem('refresh_token', refresh_token);
              return instance(originalConfig);
            })
            .catch(async (_error) => {
              localStorage.removeItem('access_token');
              localStorage.removeItem('refresh_token');
              localStorage.removeItem('role');
              localStorage.removeItem('user_name');
              localStorage.removeItem('cooperator_id');
              localStorage.setItem(
                'login_error_message',
                'トークンの有効期限が切れました。再度ログインしてください。'
              );
              await delete axios.defaults.headers.common['Authorization'];
              // @ts-ignore
              Promise.reject(_error);
              window.location.href = '/';
              tokenExpiredRetry = false;
            });
        }
        if (error.response.data.message === 'meikantoku jwt expired') {
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('role');
          localStorage.removeItem('user_name');
          localStorage.removeItem('cooperator_id');
          localStorage.setItem(
            'login_error_message',
            'トークンの有効期限が切れました。再度ログインしてください。'
          );
          await delete axios.defaults.headers.common['Authorization'];
          // @ts-ignore
          window.location = '/';
        }
        if (error.response.data.message === 'No auth token') {
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('role');
          localStorage.removeItem('user_name');
          localStorage.removeItem('cooperator_id');
          localStorage.setItem(
            'login_error_message',
            'トークンの有効期限が切れました。再度ログインしてください。'
          );
          await delete axios.defaults.headers.common['Authorization'];
          // @ts-ignore
          window.location = '/';
        }
      }
    }
    if (!error.response) {
      toast.error(
        'サーバーとの接続が切れました。ネットワーク接続をご確認いただくか、しばらくしてから再度ログインしてください。'
      );

      return Promise.resolve({
        data: null,
        status: 200,
        statusText: 'Network Error Handled',
        headers: {},
        config: originalConfig,
      });
    }
    return Promise.reject(error);
  }
);
